import React, { useState } from 'react';

const initialForm = {
  firm_code: '',
  firm_name: '',
  owner_name: '',
  mobile: '',
  email: '',
  address: '',
  gst_number: '',
  pan_number: '',
  bank_name: '',
  account_holder_name: '',
  account_number: '',
  ifsc_code: '',
};

const fields = [
  { name: 'firm_code', label: 'Firm Code', required: true },
  { name: 'firm_name', label: 'Firm Name', required: true },
  { name: 'owner_name', label: 'Owner Name' },
  { name: 'mobile', label: 'Mobile Number', type: 'tel' },
  { name: 'email', label: 'Email Address', type: 'email' },
  { name: 'gst_number', label: 'GST Number' },
  { name: 'pan_number', label: 'PAN Number' },
  { name: 'bank_name', label: 'Bank Name' },
  { name: 'account_holder_name', label: 'Account Holder Name' },
  { name: 'account_number', label: 'Account Number' },
  { name: 'ifsc_code', label: 'IFSC Code' },
];

const CreateFirmForm = ({
  initialValues,
  onSubmit,
  onCancel,
  submitting = false,
  submitLabel = 'Create Firm',
}) => {
  const [form, setForm] = useState(() => ({
    ...initialForm,
    ...(initialValues || {}),
  }));

  const [error, setError] = useState('');

  const handleChange = (event) => {
    const { name, value } = event.target;

    setForm((previous) => ({
      ...previous,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');

    if (!form.firm_code.trim() || !form.firm_name.trim()) {
      setError('Firm code and firm name are required.');
      return;
    }

    try {
      const payload = Object.fromEntries(
        Object.entries(form).map(([key, value]) => [
          key,
          typeof value === 'string' ? value.trim() : value,
        ])
      );

      await onSubmit(payload);
    } catch (err) {
      setError(
        err.response?.data?.message ||
          err.message ||
          'Unable to save the firm.'
      );
    }
  };

  return (
    <form className="admin-form" onSubmit={handleSubmit}>
      <div className="admin-form-heading">
        <h2>Firm Information</h2>
        <p>Enter the business and contact details below.</p>
      </div>

      {error && (
        <div className="admin-form-error" role="alert">
          {error}
        </div>
      )}

      <div className="admin-form-grid">
        {fields.map((field) => (
          <div className="admin-form-field" key={field.name}>
            <label htmlFor={`firm-${field.name}`}>
              {field.label}
              {field.required && <span aria-hidden="true"> *</span>}
            </label>

            <input
              id={`firm-${field.name}`}
              name={field.name}
              type={field.type || 'text'}
              value={form[field.name] ?? ''}
              onChange={handleChange}
              required={Boolean(field.required)}
              maxLength={
                field.name === 'firm_code'
                  ? 30
                  : field.name === 'firm_name'
                    ? 200
                    : field.name === 'owner_name' ||
                        field.name === 'account_holder_name' ||
                        field.name === 'bank_name'
                      ? 150
                      : field.name === 'mobile'
                        ? 20
                        : field.name === 'email'
                          ? 255
                          : field.name === 'gst_number'
                            ? 15
                            : field.name === 'pan_number'
                              ? 10
                              : field.name === 'ifsc_code'
                                ? 11
                                : field.name === 'account_number'
                                  ? 50
                                  : undefined
              }
            />
          </div>
        ))}

        <div className="admin-form-field admin-form-field-full">
          <label htmlFor="firm-address">Address</label>
          <textarea
            id="firm-address"
            name="address"
            rows={3}
            value={form.address}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="admin-form-actions">
        {onCancel && (
          <button
            type="button"
            className="admin-button admin-button-secondary"
            onClick={onCancel}
            disabled={submitting}
          >
            Cancel
          </button>
        )}

        <button
          type="submit"
          className="admin-button admin-button-primary"
          disabled={submitting}
        >
          {submitting ? 'Saving...' : submitLabel}
        </button>
      </div>
    </form>
  );
};

export default CreateFirmForm;